import React from "react";
// import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle";
// import "./landing.css"
import logo from "../../images/logonew.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useParams } from "react";
import axios from "axios";
// import DatePicker from "react-datepicker";
// import { format } from 'date-fns'
// import { Col, Row } from "react-bootstrap";
// import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import Navbar from "../Navbar/Navbar";
import "./style.css";

const KEY = "123456789";
// import "./Login.css"

const Login = ({ setPassMain, setUsernameMain, setUserMain }) => {
  const [User, setUser] = useState();
  const [UserForget, setUserForget] = useState();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [Password, setPassword] = useState();
  const [ids, setids] = useState([]);
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const sign = require("jwt-encode");
  const today = new Date();
  const [showForgetPass, setShowForgetPass] = useState(false);

  const navigate = useNavigate();

  function Passwords() {
    const password = document.getElementById("password").value;
    setPassword(password);
  }
  function Username() {
    const username = document.getElementById("username").value;
    setUser(username);
  }
  function getUserForget() {
    const usernameForget = document.getElementById("usernameForget").value;
    setUserForget(usernameForget);
  }
  const forgetPassHandler = (e) => {
    e.preventDefault();
    var fdata = new FormData();
    fdata.append("user_email", UserForget);
    axios
      .patch(
        "https://maps-medics-be.onrender.com/customer_forget_password",
        fdata
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.success)
          Swal.fire({
            position: "center",
            icon: "success",
            title: "An Email has been sent to you to reset your password.",
            showConfirmButton: false,
            timer: 1500,
          });
      })
      .catch((err) => console.log(err));
  };

  let handleOnChange = (email) => {
    // don't remember from where i copied this code, but this works.
    setUser(email);
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      // this is a valid email address
      // call setState({email: email}) to update the email
      // or update the data in redux store.
      const username = document.getElementById("username").value;
      setUser(username);
      setFlag(true);
    } else {
      // invalid email, maybe show an error to the user.
      setFlag(false);
    }
  };

  // function SendData(e, s) {
  //   setids(s);

  //   e.preventDefault()
  //   axios.post('https://maps-medics-be.onrender.com/user_login',{"email":User,"password":Password})
  //   .then((response) => {
  //     let x = jwtDecode(response.data.token)
  //     console.log(x)
  //     if (x.success === true){
  //       // sessionStorage.setItem("cource_id", s);
  //       var user_HASHED = sign(User, KEY);
  //       var pwd_HASHED = sign(Password, KEY);

  //       setPassMain(pwd_HASHED);
  //       setUsernameMain(user_HASHED);
  //       sessionStorage.setItem('loggedIn', true);
  //       setUserMain(x)
  //       sessionStorage.setItem('user_id', x.user_id);
  //       sessionStorage.setItem('user_image', x.image);

  //         // Set the user's login status to true in local storage
  //       if (sessionStorage.getItem('cource_id') && sessionStorage.getItem('loggedIn')) {
  //         // Check if the user is logged in and has a course ID set in local storage
  //         navigate('/')
  //         // + sessionStorage.getItem('cource_id' , s));
  //         console.log('true')
  //       } else {
  //         navigate('/'); // If the user is not logged in or does not have a course ID set, redirect to the login page
  //         console.log('false')

  //       }
  //       Swal.fire({
  //         position: 'center',
  //         icon: 'success',
  //         title: 'Welcome',
  //         showConfirmButton: false,
  //         timer: 1500

  //       }).then(() => {
  //      console.log('here')
  //       });
  //     }
  //     })
  //   };

  function SendData(e) {
    // setids(s);

    e.preventDefault();
    axios
      .post("https://maps-medics-be.onrender.com/user_login", {
        email: User,
        password: Password,
        platform:'website'
      })
      .then((response) => {
        let x = jwtDecode(response.data.token);
        console.log(x);
        let v = x.token;
        console.log(x.token);
        if (x.success === true) {
          // sessionStorage.setItem("cource_id", s);
          var user_HASHED = sign(User, KEY);
          var pwd_HASHED = sign(Password, KEY);
          console.log(v);

          setPassMain(pwd_HASHED);
          setUsernameMain(user_HASHED);
          sessionStorage.setItem("loggedIn", true);
          setUserMain(x);
          sessionStorage.setItem("user_image", x.image);
          sessionStorage.setItem("user_email", x.email);
console.log(x.email);
          console.log(typeof x.image);
          sessionStorage.setItem("logged_once", true);
          sessionStorage.setItem("token", v);

          sessionStorage.setItem("user_id", x.user_id); // Set the user's login status to true in local storage
          if (
            sessionStorage.getItem("cource_id") &&
            sessionStorage.getItem("loggedIn")
          ) {
            // Check if the user is logged in and has a course ID set in local storage
            navigate("/courses");
            // navigate("/courseDetails/" + sessionStorage.getItem("cource_id"));
            console.log("true");
          } else {
            navigate("/"); // If the user is not logged in or does not have a course ID set, redirect to the login page
            console.log("false");
          }
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Welcome",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            console.log("here");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: '<a href="">Why do I have this issue?</a>',
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <>
      {/* <Navbar/> */}
      <div
        className="section page-banner-login "
        style={{ position: "relative" }}
      >
        <div
          className="container p-3"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
          }}
        >
          {/* <div className="first"><img src={logo} alt="neon" className="ad" /></div>
        <hr style={{color:"gray" ,fontSize:20}}/> */}
          <div
            className="row h-25"
            style={{ marginTop: windowSize.height < 550 ? "5%" : "0" }}
          >
            <div className="col-md-7 p-3">
              <img
                src={logo}
                alt=""
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  maxWidth: "86%",
                }}
                class="w3-animate-opacity"
              />
              <div
                className="w3-center w3-animate-top"
                style={{ marginTop: "5%" }}
              >
                <h1
                  style={{
                    fontWeight: "900",
                    fontSize: "4em",
                    color: "#ffc600",
                    lineHeight: "1.2em",
                    fontFamily: "Playfair Display",
                    textAlign: "left",
                    marginLeft: "8%",
                  }}
                >
                  Welcome Back !
                </h1>
                <p
                  style={{
                    margin: "0",
                    fontSize: "20px",
                    lineHeight: "1",
                    fontWeight: "400",
                    fontFamily: "Segoe UI",
                    color: "#000",
                    textAlign: "left",
                    marginTop: "3%",
                    marginLeft: "7%",
                  }}
                >
                  Sign in to your account using this form. Please feel free to
                  reach us any time if you have any issues signing into your
                  account.
                </p>
              </div>
            </div>
            {showForgetPass === false ? (
              <>
                <div style={{ marginBottom: "4%" }} className="col-md-5 w3-container w3-center w3-animate-bottom">
                  <form
                    className="secound "
                    style={{ width: "90%", marginLeft: "5%" }}
                  >
                    <h1
                      className="text-center p-3"
                      style={{
                        color: "#ffc600",
                        lineHeight: "1.2em",
                        fontWeight: "900",
                        marginTop: "5%",
                      }}
                    >
                      Sign in
                    </h1>
                    <div className="container">
                      <div
                        className="row"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div className="col-md-10">
                          <div
                            style={{
                              paddingBottom: "2%",
                              position: "relative",
                            }}
                          >
                            {/* <div className="um-field-icon" style={{position:'absolute', cursor:'default', textAlign:'center', top:'2px', left:"0", width:'44px', fontSize:'22px', lineHeight:'1.7em'}}>
<i class="fa-solid fa-at" style={{color:'#aaaaaa'}}></i>
</div> */}
                            <div style={{ margin: "auto" }}>
                              <div class="form__group field">
                                <input
                                  class="form__field"
                                  name="name"
                                  required
                                  id="username"
                                  type="email"
                                  // className="form-control p-3"
                                  placeholder=" Username or E-mail"
                                  onChange={(e) => {
                                    handleOnChange(e.target.value);
                                  }}
                                />
                                <div className="iconWrap">
                                  <i class="fa-solid fa-at"></i>
                                </div>
                                <label
                                  for="name"
                                  class="form__label"
                                  onClick={() => {
                                    document.getElementById("username").focus();
                                  }}
                                >
                                  Email
                                </label>
                                {flag ? (
                                  <div className="ourTick">
                                    <i
                                      class="fa fa-check-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                ) : (
                                  User !== "" && (
                                    <div
                                      className="ourx"
                                      onClick={() => {
                                        document.getElementById(
                                          "username"
                                        ).value = "";
                                        setUser("");
                                      }}
                                    >
                                      <i
                                        class="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>

                            {/* <input
                          style={{
                            textAlign: "left",
                            borderBottom: "3px solid #ccc ",
                            padding: "12px 20px 20px 40px",
                            transition: "0.5s all",
                            color: "#666666",
                            backgroundColor: "#ffffff",
                            borderTop: "none",
                            borderRight: "none",
                            borderLeft: "none",
                          }}
                          id="username"
                          type="email"
                          // className="form-control p-3"
                          placeholder=" Username or E-mail"
                          onChange={Username}
                        /> */}
                            <div
                              style={{
                                paddingBottom: "2%",
                                position: "relative",
                              }}
                            >
                              <div style={{ margin: "auto" }}>
                                <div class="form__group field">
                                  <input
                                    class="form__field"
                                    required
                                    id="password"
                                    type={show ? "text" : "Password"}
                                    // className="form-control p-3"
                                    placeholder=" Username or E-mail"
                                    onChange={Passwords}
                                  />
                                  <div className="iconWrap">
                                    <i class="fa-solid fa-lock"></i>
                                  </div>
                                  <div
                                    className="ourx"
                                    onClick={() => {
                                      setShow(!show);
                                    }}
                                  >
                                    <i
                                      class="fa fa-eye fa-2xs"
                                      aria-hidden="true"
                                      style={{
                                        color: show ? "#ffc600" : "black",
                                      }}
                                    ></i>
                                  </div>
                                  <label
                                    for="name"
                                    class="form__label"
                                    onClick={() => {
                                      document
                                        .getElementById("password")
                                        .focus();
                                    }}
                                  >
                                    Password
                                  </label>
                                </div>
                              </div>
                              {/* <div className="iconWrap">
                            <i class="fa-solid fa-lock"></i>
                          </div>
                          <input
                            style={{
                              textAlign: "left",
                              borderBottom: "3px solid #ccc ",
                              padding: "12px 20px 20px 40px",
                              transition: "0.5s all",
                              color: "#666666",
                              backgroundColor: "#ffffff",
                              borderTop: "none",
                              borderRight: "none",
                              borderLeft: "none",
                            }}
                            id="password"
                            type="password"
                            // className="form-control p-3"
                            placeholder="Password"
                            onChange={Passwords}
                          /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <button
                        style={{
                          marginTop: "8%",
                          width: "65%",

                          marginBottom: "6%",
                        }}
                        onClick={(e) => SendData(e)}
                        type="submit"
                        className="btn startLearningAdver"
                      >
                        Login
                      </button>
                    </div>
                    <label
                      style={{
                        color: "#ffc600",
                        marginBottom: "6%",
                        cursor: "pointer",
                      }}
                      onClick={() => setShowForgetPass(true)}
                    >
                      Forgot Password?
                    </label>
                    <br />
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: "#000",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <label style={{ color: "#fff", marginRight: "5px" }}>
                        Want to create a new account?
                      </label>

                      <Link
                        to="/register"
                        style={{ color: "#ffc600", textDecoration: "none" }}
                      >
                        Sign Up Here!
                      </Link>
                    </div>
                  </form>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-4 w3-container w3-center w3-animate-bottom">
                  <form className="secound ">
                    <h3
                      className="text-center p-3"
                      style={{
                        fontSize: "1.625rem",
                        color: "#ffc600",
                        lineHeight: "1.2em",
                        fontWeight: "900",
                      }}
                    >
                      Sign in
                    </h3>
                    <div className="container">
                      <div
                        className="row"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div className="col-md-10">
                          <div
                            style={{
                              paddingBottom: "2%",
                              position: "relative",
                            }}
                          >
                            {/* Omar Sameh */}
                            {/* <div className="um-field-icon" style={{position:'absolute', cursor:'default', textAlign:'center', top:'2px', left:"0", width:'44px', fontSize:'22px', lineHeight:'1.7em'}}>
<i class="fa-solid fa-at" style={{color:'#aaaaaa'}}></i>
</div> */}
                          </div>
                          <div class="form__group field">
                            <input
                              class="form__field"
                              name="name"
                              required
                              id="usernameForget"
                              type="email"
                              // className="form-control p-3"
                              placeholder=" Username or E-mail"
                              onChange={getUserForget}
                            />
                            <div className="iconWrap">
                              <i class="fa-solid fa-at"></i>
                            </div>
                            <label
                              for="name"
                              class="form__label"
                              onClick={() => {
                                document.getElementById("usernameForget").focus();
                              }}
                            >
                              Email
                            </label>
                            {flag ? (
                              <div className="ourTick">
                                <i
                                  class="fa fa-check-circle"
                                  aria-hidden="true"
                                ></i>
                              </div>
                            ) : (
                              User !== "" && (
                                <div
                                  className="ourx"
                                  onClick={() => {
                                    document.getElementById("username3").value =
                                      "";
                                    UserForget("");
                                  }}
                                >
                                  <i class="fa fa-times" aria-hidden="true"></i>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        style={{
                          marginTop: "10%",
                          background: "#242A56",
                          width: "40%",
                          border: "1px solid #242A56",
                        }}
                        onClick={(e) => forgetPassHandler(e)}
                        type="submit"
                        className="btn startLearningAdver"
                      >
                        Submit
                      </button>
                    </div>
                    <br />
                  </form>
                </div>
              </>
            )}
          </div>
          <div
            class=""
            style={{ position: "absolute", bottom: "0", width: "100%" }}
          >
            <div className="container">
              <div
                className="row p-2"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {/* <div className="col-md-6 ">
              <div className="row" style={{ display: "block" }}>
                <a
                  href="https://neoneg.com/"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  www.neoneg.com
                </a>
              
              </div>
            </div> */}
                <div
                  className="col-md-12"
                  style={{ display: "flex", justifyContent: "center", }}
                >
                  <p
                    style={{
                      margin: "0",
                      fontSize: "15px",
                      lineHeight: "1.8",
                      fontWeight: "700",
                      fontFamily: "Segoe UI",
                      color: "#000",

                    }}
                  >
                    Copyright &copy; {today.getFullYear()} by{" "}
                    <span>
                      {" "}
                      <a
                        href="https://neoneg.com/"
                        style={{
                          cursor: "pointer",
                          textDecoration: "none",
                          color: "#000",
                          fontWeight: "700",
                        }}
                      >
                        NEON
                      </a>{" "}
                    </span>
                    <a
                      href=""
                      style={{ textDecoration: "none", fontWeight: "700" }}
                      onClick={() => {
                        window.open(`https://wa.me/+201113588988`);
                      }}
                    >
                      <i
                        className="fa-brands fa-whatsapp fs-5"
                        style={{ color: "#000", marginRight: "10px" }}
                      ></i>
                    </a>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row"></div> */}
      </div>
    </>
  );
};
export default Login;
